module.exports = __webpack_public_path__ + "static/media/ic-info.ec13ded6.svg";